(function (window, $) {
  var Cls = {};

  var firstFlag = false;
  var DELAY = 1000;
  var $title = null;
  var $ducted_0 = null;
  var $earth0 = null;
  var $ductless_0 = null;
  var $ducted_icon = null;
  var $ductless_1 = null;
  var $earth1 = null;
  var $ducted_1 = null;
  var $ductless_icon = null;

  Cls.isAnimated = false;

  Cls.init = function () {
    $title = $("#seg5 .title1");
    $ducted_0 = $("#seg5 .cat0 .obj1");
    $earth0 = $("#seg5 .cat0 .obj2");
    $ductless_0 = $("#seg5 .cat0 .obj3");
    $ducted_icon = $("#seg5 .cat0 .obj4");

    $ductless_1 = $("#seg5 .cat1 .obj1");
    $earth1 = $("#seg5 .cat1 .obj2");
    $ducted_1 = $("#seg5 .cat1 .obj3");
    $ductless_icon = $("#seg5 .cat1 .obj4");
    Cls.allAlpha();
  };
  Cls.fixedAreaAnime = function () {
    if (firstFlag !== true) {
      Anime.vertical($title, "-=100px", 700, 1200, "easeOutQuint");
      DELAY = 0;
      firstFlag = true;
    }
  };
  Cls.cat0 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;

      //
      if (firstFlag !== true) {
        Cls.cat1Alpha();
      } else {
        Cls.cat1Reverse();
      }

      $ductless_0.css({ left: "668px", top: "280px" });
      $ducted_0.css({ left: "98px", top: "210px" });
      $("img", $ductless_0).css({ width: "131px", height: "131px" });
      $("img", $ducted_0).css({ width: "290px", height: "272px" });
      $("img", $ductless_1).css({ width: "290px", height: "272px" });
      $("img", $ducted_1).css({ width: "131px", height: "131px" });

      $earth0.delay(600).animate({ opacity: "1" }, 1500, "easeOutQuint");
      $earth1.delay(600).animate({ opacity: "0" }, 1500, "easeOutQuint");

      Anime.zoomIn($ductless_0, 1000, "easeOutBack", DELAY + 600);
      Anime.zoomIn($ducted_0, 1000, "easeOutBack", DELAY + 600);
      Anime.vertical(
        $ducted_icon,
        "-=100px",
        DELAY + 1300,
        1000,
        "easeOutBack",
        function () {
          Cls.isAnimated = false;
        }
      );

      Cls.fixedAreaAnime();
    }
  };
  Cls.cat1 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;

      if (firstFlag !== true) {
        Cls.cat0Alpha();
      } else {
        Cls.cat0Reverse();
      }

      $ductless_1.css({ left: "570px", top: "210px" });
      $ducted_1.css({ left: "168px", top: "280px" });
      $("img", $ductless_0).css({ width: "131px", height: "131px" });
      $("img", $ducted_0).css({ width: "290px", height: "272px" });
      $("img", $ductless_1).css({ width: "290px", height: "272px" });
      $("img", $ducted_1).css({ width: "131px", height: "131px" });

      $earth0.delay(600).animate({ opacity: "0" }, 1500, "easeOutQuint");
      $earth1.delay(600).animate({ opacity: "1" }, 1500, "easeOutQuint");

      Anime.zoomIn($ductless_1, 1000, "easeOutBack", 600);
      Anime.zoomIn($ducted_1, 1000, "easeOutBack", 600);
      Anime.vertical(
        $ductless_icon,
        "-=100px",
        1300,
        1000,
        "easeOutBack",
        function () {
          Cls.isAnimated = false;
        }
      );

      Cls.fixedAreaAnime();
    }
  };

  Cls.cat0Alpha = function () {
    $ducted_0.animate({ opacity: "0" }, 1000, "easeOutQuint");
    $earth0.delay(1000).animate({ opacity: "0" }, 1000, "easeOutQuint");
    $ductless_0.animate({ opacity: "0" }, 1000, "easeOutQuint");
    $ducted_icon.animate({ opacity: "0" }, 1000, "easeOutQuint");
  };
  Cls.cat1Alpha = function () {
    $ductless_1.animate({ opacity: "0" }, 1000, "easeOutQuint");

    $earth1.animate({ opacity: "0" }, 1000, "easeOutQuint");
    $ducted_1.animate({ opacity: "0" }, 1000, "easeOutQuint");
    $ductless_icon.animate({ opacity: "0" }, 1000, "easeOutQuint");
  };
  Cls.cat0Reverse = function () {
    Anime.zoomOutFade($ducted_0, 500, "easeOutQuint", 400, null, {
      img_w: 290,
      img_h: 272,
    });
    Anime.zoomOutFade($ductless_0, 500, "easeOutQuad", 800, null, {
      img_w: 131,
      img_h: 131,
    });
    $ducted_icon.animate({ opacity: "0" }, 1000, "easeOutQuint");
  };

  Cls.cat1Reverse = function () {
    Anime.zoomOutFade($ducted_1, 500, "easeOutQuint", 400, null, {
      img_w: 290,
      img_h: 272,
    });
    Anime.zoomOutFade($ductless_1, 500, "easeOutQuad", 800, null, {
      img_w: 131,
      img_h: 131,
    });
    $ductless_icon.animate({ opacity: "0" }, 1000, "easeOutQuint");
  };

  Cls.allAlpha = function () {
    $ducted_0.css({ opacity: "0" });
    $earth0.css({ opacity: "0" });
    $ductless_0.css({ opacity: "0" });
    $ducted_icon.css({ opacity: "0" });
    $ductless_1.css({ opacity: "0" });
    $earth1.css({ opacity: "0" });
    $ducted_1.css({ opacity: "0" });
    $ductless_icon.css({ opacity: "0" });
  };

  window.Seg5 = Cls;
})(window, $brand);
